function copyWidgetCode(btn) {
    var code = btn.previousElementSibling.innerText;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function() {
        btn.innerText = "Copied!";
        setTimeout(function(){ btn.innerText = "Copy"; }, 1500);
      });
    } else {
      // Fallback for older browsers or environments
      var textarea = document.createElement("textarea");
      textarea.value = code;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        btn.innerText = "Copied!";
        setTimeout(function(){ btn.innerText = "Copy"; }, 1500);
      } catch (err) {
        alert('Copy failed');
      }
      document.body.removeChild(textarea);
    }
  }

export default copyWidgetCode;